import { createStore } from 'vuex'

// Store modules
import auth from './auth'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
  }
})
